/* ─────────────────────────────────────────────────────────────
   Lillbud Contact Us — Shared JavaScript
   Handles:
     1. Self-service tab switching (crossfade, no page jump)
     2. FAQ accordion (one open at a time)
     3. Form topic chips + conditional order number field
     4. Character counter
     5. Form validation + success state
   ───────────────────────────────────────────────────────────── */

(function () {
  'use strict';

  /* ── 1. SELF-SERVICE TABS ─────────────────────────────────── */
  function initTabs() {
    const topics = document.querySelectorAll('.cu-qh-topic');
    const panels = document.querySelectorAll('.cu-panel-wrap');
    if (!topics.length) return;

    function setTab(panelId) {
      topics.forEach(function (t) {
        var on = t.dataset.panel === panelId;
        t.classList.toggle('active', on);
        t.setAttribute('aria-selected', String(on));
      });
      panels.forEach(function (p) {
        var on = p.id === panelId;
        p.classList.toggle('active', on);
        p.setAttribute('aria-hidden', String(!on));
      });
    }

    topics.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setTab(btn.dataset.panel);
      });
    });
  }

  /* ── 2. FAQ ACCORDION ─────────────────────────────────────── */
  function initFaq() {
    var items = document.querySelectorAll('.cu-fi-item');
    if (!items.length) return;

    function closeAll(except) {
      items.forEach(function (item) {
        if (item === except) return;
        item.classList.remove('open');
        var btn = item.querySelector('.cu-fi-q');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    }

    items.forEach(function (item) {
      var btn = item.querySelector('.cu-fi-q');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var wasOpen = item.classList.contains('open');
        closeAll(wasOpen ? null : item);
        if (!wasOpen) {
          item.classList.add('open');
          btn.setAttribute('aria-expanded', 'true');
        } else {
          item.classList.remove('open');
          btn.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  /* ── 3. FORM TOPIC CHIPS ──────────────────────────────────── */
  // function initFormChips() {
  //   var chips = document.querySelectorAll('.cu-tc');
  //   var ordWrap = document.getElementById('cu-fi-ordnum');
  //   if (!chips.length) return;

  //   chips.forEach(function (chip) {
  //     chip.addEventListener('click', function () {
  //       chips.forEach(function (c) { c.classList.remove('sel'); });
  //       chip.classList.add('sel');
  //       if (ordWrap) {
  //         var needsOrder = ['order', 'return'].indexOf(chip.dataset.topic) !== -1;
  //         ordWrap.style.display = needsOrder ? 'flex' : 'none';
  //       }
  //     });
  //   });
  // }

  function initFormChips() {
  var chips = document.querySelectorAll('.cu-tc');
  var ordWrap = document.getElementById('cu-fi-ordnum');
  var topicInput = document.getElementById('cu-selected-topic');

  if (!chips.length) return;

  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      chips.forEach(function (c) {
        c.classList.remove('sel');
      });

      chip.classList.add('sel');

      // Update hidden field sent to Shopify
      if (topicInput) {
        topicInput.value = chip.textContent.trim();
      }

      if (ordWrap) {
        var needsOrder = ['order', 'return'].indexOf(chip.dataset.topic) !== -1;
        ordWrap.style.display = needsOrder ? 'flex' : 'none';
      }
    });
  });
  // Set initial state based on the default selected chip
var selectedChip = document.querySelector('.cu-tc.sel');

if (selectedChip) {
  if (topicInput) {
    topicInput.value = selectedChip.textContent.trim();
  }

  if (ordWrap) {
    var needsOrder = ['order', 'return'].includes(selectedChip.dataset.topic);
    ordWrap.style.display = needsOrder ? 'flex' : 'none';
  }
}
}

  /* ── 4. CHARACTER COUNTER ─────────────────────────────────── */
  function initCharCounter() {
    var area = document.getElementById('cu-fmsg');
    var counter = document.getElementById('cu-char-cnt');
    if (!area || !counter) return;
    area.addEventListener('input', function () {
      var len = area.value.length;
      counter.textContent = len + ' / 800';
      counter.classList.toggle('warn', len >= 700);
    });
  }

  /* ── 5. FORM VALIDATION + SUCCESS ────────────────────────── */
  function initForm() {
    var form = document.getElementById('cu-contact-form');
    var success = document.getElementById('cu-form-success');
    if (!form || !success) return;

    form.addEventListener('submit', function (e) {
      /* Let Shopify handle the actual submission — only validate client-side */
      var valid = true;
      ['cu-fname', 'cu-femail', 'cu-fmsg'].forEach(function (id) {
        var el = document.getElementById(id);
        if (!el) return;
        if (!el.value.trim()) {
          el.classList.add('err');
          valid = false;
          el.addEventListener('input', function () { el.classList.remove('err'); }, { once: true });
        }
      });
      var emailEl = document.getElementById('cu-femail');
      if (emailEl && emailEl.value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailEl.value)) {
        emailEl.classList.add('err');
        valid = false;
      }
      if (!valid) e.preventDefault();
    });
  }

  /* ── INIT ─────────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    initTabs();
    initFaq();
    initFormChips();
    initCharCounter();
    initForm();
  }
})();
